import React, { useState, useEffect } from "react";
import IleyaSavingsDataService from "../services/IleyaSavingsService";

const IleyaSavings = props => {
  const initialIleyaSavingsState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentIleyaSavings, setCurrentIleyaSavings] = useState(initialIleyaSavingsState);
  const [message, setMessage] = useState("");

  const getIleyaSavings = id => {
    IleyaSavingsDataService.get(id)
      .then(response => {
        setCurrentIleyaSavings(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getIleyaSavings(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentIleyaSavings({ ...currentIleyaSavings, [name]: value });
  };

  const updateIleyaSavings = () => {
    IleyaSavingsDataService.update(currentIleyaSavings.id, currentIleyaSavings)
      .then(response => {
        console.log(response.data);
        setMessage("Ileya Savings transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteIleyaSavings = () => {
    IleyaSavingsDataService.remove(currentIleyaSavings.id)
      .then(response => {
        console.log(response.data);
        props.history.push("/ileyasavings");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentIleyaSavings ? (
        <div className="edit-form">
          <h4>Ileya Savings Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentIleyaSavings.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentIleyaSavings.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentIleyaSavings.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteIleyaSavings}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateIleyaSavings}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on Ileya Savings Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default IleyaSavings;
